/*
    Controller to launch the dialog used to edit a device group name or description
*/

import Radio from 'backbone.radio';
import DevelopmentDeviceGroupSettingsDialog from '@/views/dialogs/development_devicegroup_settings';

export default function show_development_devicegroup_settings_dialog(devicegroup) {
    var globalCh = Radio.channel('global');
    let options = {
        name_label: 'Device Group Name',
        description_label: 'Device Group Description',
        dialog_title: 'Development Device Group Settings: ',
        name: devicegroup.get('name'),
        model: devicegroup,
        cancel: 'Cancel',
        submit_text: 'Update'
    };
    let development_devicegroup_settings_dialog = new DevelopmentDeviceGroupSettingsDialog(options);
    globalCh.request('showDialog', development_devicegroup_settings_dialog);
}

